import { gql } from '@apollo/client';

export type CreateI18nConfigInput = {
  messageKey: string;
  popupType: number;
  triggerScene?: string | null;
  titleZh?: string | null;
  titleEn?: string | null;
  titleEs?: string | null;
  contentZh?: string | null;
  contentEn?: string | null;
  contentEs?: string | null;
  remark?: string | null;
};

export type UpdateI18nConfigInput = {
  id: string;
  popupType: number;
  triggerScene?: string | null;
  titleZh?: string | null;
  titleEn?: string | null;
  titleEs?: string | null;
  contentZh?: string | null;
  contentEn?: string | null;
  contentEs?: string | null;
  remark?: string | null;
};

export type I18nConfigBatchFailure = {
  messageKey: string;
  reason: string;
};

export type BatchCreateI18nConfigResult = {
  succeeded: { id: string; messageKey: string }[];
  failed: I18nConfigBatchFailure[];
};

export const CREATE_I18N_CONFIG = gql`
  mutation CreateI18nConfig($input: CreateI18nConfigInput!) {
    createI18nConfig(input: $input) {
      id
      messageKey
    }
  }
`;

export const UPDATE_I18N_CONFIG = gql`
  mutation UpdateI18nConfig($input: UpdateI18nConfigInput!) {
    updateI18nConfig(input: $input) {
      id
      messageKey
    }
  }
`;

export const BATCH_CREATE_I18N_CONFIG = gql`
  mutation BatchCreateI18nConfig($items: [CreateI18nConfigInput!]!) {
    batchCreateI18nConfig(items: $items) {
      succeeded {
        id
        messageKey
      }
      failed {
        messageKey
        reason
      }
    }
  }
`;
